const PREFIX = "jmurillo.variant-filter-editor.";

const ActionTypes = Object.freeze({
	PREFIX: PREFIX,
	CLEAN: PREFIX + "clean",
	SELECT_ACTIVE_EDITOR: PREFIX + "select-active-editor",
	SET_PARAM: PREFIX + "set-param",
});


export default ActionTypes;